'use strict'
// Template version: 1.2.3
// see http://vuejs-templates.github.io/webpack for documentation.

//如果是单独的服务，请适用/school,在build前，请修改为正式的服务器地址
const serverUrl = '/zzxf';
const targetUrl = '/zzxf';
// const serverUrl = '/monitor';
// const targetUrl = 'http://192.168.0.69:89';
//是否验证用户登录信息，true:验证；false:不验证
const isValidatorUserInfo = false;
//如果不验证的模拟用户信息
const testUserInfo = {
  user:{
    id:'3',
    userName:'郑州索特',
    userAccount:'zzstxx',
    loginCount:0,
    userDate:'2010-03-01 15:28:41',
    zhdlsj:'2018-11-28 14:00:26',
    zp:''
  },
  unit:{
    id:'0101',
    unitMc:'郑州市索特实验学校'
  }
};

const path = require('path')

module.exports = {
  serverUrl:serverUrl,
  targetUrl:targetUrl,
  isValidatorUserInfo:isValidatorUserInfo,
  testUserInfo:testUserInfo,
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/monitor': {
        target: targetUrl, //设置调用接口域名和端口号别忘了加http
        changeOrigin: true,
        pathRewrite: {
          '^/monitor': '/' //这里理解成用‘/school’代替target里面的地址，组件中我们调接口时直接用api代替
          // 比如我要调用'http://localhost:80/user/add'，直接写‘/school/user/add’即可
        }
      }
    },
    // Various Dev Server settings
    host: '192.168.0.69', // can be overwritten by process.env.HOST
    port: 8088, // can be overwritten by process.env.HOST, if port is in use, a free one will be determined
    autoOpenBrowser: true,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false,
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    //打包引用的js，css文件，路径前缀
    assetsPublicPath: './',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 39